"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * settings: {
 *     icon: {
 *         name: "pencil",
 *         paths: [
 *             "M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
 *         ],
 *         viewBox: "0 0 1024 1024"
 *         width: "20",
 *         height: "20",
 *     }
 * }
 */
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var content;
    var field = (0, _get2["default"])(row, settings.path);
    if (field === '') {
      content = null;
    } else {
      content = field;
    }
    var noContent = content == null || content === undefined;
    return /*#__PURE__*/_react["default"].createElement("div", null, noContent ? /*#__PURE__*/_react["default"].createElement("span", null) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat((0, _classnames["default"])('table-renderers-icons', _style["default"].iconContainer), " text-nowrap")
    }, ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].icon
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      width: settings.icon.width,
      height: settings.icon.height,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: settings.icon.viewBox
    }, /*#__PURE__*/_react["default"].createElement("g", null, settings.icon.paths.map(function (p) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: p,
        d: p
      });
    })))), /*#__PURE__*/_react["default"].createElement("span", null, " ", " ".concat(content), " "), ' '));
  };
};